export type PromoCode = {
  id: string;
  code: string;
  discount: string;
  discount_type: string;
  duration: string;
  is_active: boolean;
};

type PromoDuration = {
  start?: string;
  to?: string;
  end?: string;
};

const toStartOfDay = (date: Date) => {
  const normalized = new Date(date);
  normalized.setHours(0, 0, 0, 0);
  return normalized;
};

const parseDate = (value: string) => {
  const match = value.trim().match(/^(\d{2})-(\d{2})-(\d{4})$/);

  if (!match) {
    return null;
  }

  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);
  const parsed = new Date(year, month - 1, day);

  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  return toStartOfDay(parsed);
};

const parseDuration = (duration: string): PromoDuration | null => {
  if (!duration.trim()) {
    return null;
  }

  try {
    return JSON.parse(duration) as PromoDuration;
  } catch {
    try {
      const normalized = duration
        .replace(/'/g, '"')
        .replace(/(\b\w+\b)\s*:/g, '"$1":');
      return JSON.parse(normalized) as PromoDuration;
    } catch {
      return null;
    }
  }
};

export const isWithinDuration = (duration: string) => {
  const parsedDuration = parseDuration(duration);

  if (!parsedDuration) {
    return false;
  }

  const startDate = parseDate(parsedDuration.start ?? "");
  const endDate = parseDate(parsedDuration.to ?? parsedDuration.end ?? "");

  if (!startDate || !endDate) {
    return false;
  }

  const today = toStartOfDay(new Date());
  return today >= startDate && today <= endDate;
};

export type CheckPromoResponse = {
  checkPromoCode: PromoCode[];
};

export type PromoState = {
  promoCodes: PromoCode[];
  isLoading: boolean;
  error: string | null;
  checkPromo: (code: string) => Promise<PromoCode[] | null>;
  clearPromo: () => void;
};
